// TSS vite/02 — centralized constants.
// Read by the page layouts (client-side head updates) and by
// entry-server.jsx (build-time prerender), so both stay in sync.

export const SITE_NAME = 'Total Medios';
export const SITE_SLOGAN = 'Todo lo que necesitas para tu medio.';
export const SITE_LOCALE = 'es_CO';
export const OG_IMAGE_PATH = '/og-image.jpg';

export const PAGE_META = {
    HOME: {
        path: '/',
        title: 'Total Medios | Todo lo que necesitas para tu medio',
        description: 'Asesoría estratégica, marketing digital, producción audiovisual y desarrollo web para medios digitales, emisoras, portales, creadores de contenido y marcas en Colombia.',
        robots: 'index,follow,max-image-preview:large',
    },
    PRIVACY: {
        path: '/politica-de-datos',
        title: 'Política de tratamiento de datos | Total Medios',
        description: 'Conoce cómo Total Medios recolecta, usa y protege tus datos personales conforme a la Ley 1581 de 2012 y cómo ejercer tus derechos como titular.',
        robots: 'index,follow',
    },
    NOT_FOUND: {
        path: '/404',
        title: 'Página no encontrada | Total Medios',
        description: 'La página que buscas no existe o fue movida. Vuelve al inicio de Total Medios.',
        robots: 'noindex,follow',
    },
};
